export const FORGOT_PASSWORD_BASE_ROUTE = '/forgot-password'
export const FORGOT_PASSWORD_SUCCESS_ROUTE = '/forgot-password-success'
export const FORGOT_PASSWORD_SUCCESS_HEADING = 'Check Your Email'
export const FORGOT_PASSWORD_SUCCESS_CONTENT = 'A password reset link has been sent.'
export const SUBMIT_FORGOT_PASSWORD = 'SUBMIT_FORGOT_PASSWORD'
export const FORGOT_PASSWORD_SET_IS_LOADING = 'FORGOT_PASSWORD_SET_IS_LOADING'
export const FORGOT_PASSWORD_SET_SERVER_ERROR = 'FORGOT_PASSWORD_SET_SERVER_ERROR'
